// Notification utility with sound support

// Create a simple notification sound using Web Audio API
const createNotificationSound = () => {
  try {
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();

    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);

    oscillator.frequency.value = 800; // Higher pitch
    oscillator.type = 'sine';

    gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.3);

    oscillator.start(audioContext.currentTime);
    oscillator.stop(audioContext.currentTime + 0.3);
  } catch (error) {
    console.warn('Could not play notification sound:', error);
  }
};

// Request notification permission
export const requestNotificationPermission = async () => {
  if (!('Notification' in window)) {
    console.warn('This browser does not support notifications');
    return false;
  }

  if (Notification.permission === 'granted') {
    return true;
  }

  if (Notification.permission !== 'denied') {
    const permission = await Notification.requestPermission();
    return permission === 'granted';
  }

  return false;
};

// Show browser notification
export const showNotification = (title, options = {}) => {
  if (!('Notification' in window)) {
    return;
  }

  if (Notification.permission === 'granted') {
    const notification = new Notification(title, {
      icon: '/favicon.ico',
      badge: '/favicon.ico',
      ...options,
    });

    // Auto close after 5 seconds
    setTimeout(() => {
      notification.close();
    }, 5000);

    // Handle click
    notification.onclick = () => {
      window.focus();
      notification.close();
    };

    return notification;
  }
};

// Show message notification with sound
export const notifyNewMessage = (senderName, message, chatType = 'chat') => {
  // Play sound
  createNotificationSound();

  // Show browser notification (only if page is not focused)
  if (document.hidden || !document.hasFocus()) {
    const title = chatType === 'expert' 
      ? `New message from ${senderName}`
      : `New message from ${senderName}`;
    
    const body = message.length > 50 ? message.substring(0, 50) + '...' : message;
    
    showNotification(title, {
      body,
      tag: `message-${Date.now()}`, // Prevent duplicate notifications
      requireInteraction: false,
    });
  }
};

// Show expert chat notification
export const notifyExpertChatJoined = (adminName) => {
  createNotificationSound();
  
  if (document.hidden || !document.hasFocus()) {
    showNotification('Expert Joined', {
      body: `${adminName} has joined your chat`,
      tag: `expert-joined-${Date.now()}`,
      requireInteraction: false,
    });
  }
};


